<template>
  <div class="flight-fields">
    <section v-for="side in visibleSides" :key="side.key" class="flight-section">
      <h4>{{ side.label }}</h4>
      <div class="flight-grid">
        <v-text-field v-model="value[side.key].date" label="Flugdatum" type="date" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].airline" label="Fluggesellschaft" maxlength="100" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].number" label="Flugnummer (optional)" maxlength="30" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].from" label="Abflughafen, z. B. ZRH" maxlength="4" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].departure" label="Abflugzeit (Ortszeit)" type="time" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].to" label="Zielflughafen, z. B. AYT" maxlength="4" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].arrival" label="Ankunftszeit (Ortszeit)" type="time" outlined dense hide-details="auto" />
        <v-text-field v-model="value[side.key].arrivalDate" label="Ankunftsdatum (optional)" type="date" hint="Leer = gleiches Datum wie der Abflug" persistent-hint outlined dense />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AlibeyFlightFields",
  props: { value: { type: Object, required: true }, side: { type: String, default: "" } },
  computed: { visibleSides() { return this.sides.filter(side => !this.side || side.key === this.side) } },
  data: () => ({ sides: [{ key: "outbound", label: "Hinflug" }, { key: "inbound", label: "Rückflug" }] }),
}
</script>

<style scoped>
.flight-section + .flight-section { margin-top: 1.25rem; }
h4 { font-size: 1rem; font-weight: 600; margin: 0 0 .875rem; }
.flight-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; }
.flight-fields ::v-deep input, .flight-fields ::v-deep .v-label { font-size: 1rem; }
.flight-fields ::v-deep .v-messages { font-size: .875rem; }
@media (max-width: 600px) { .flight-grid { grid-template-columns: minmax(0, 1fr); } }
</style>
